module.exports = __webpack_public_path__ + "static/media/Icon-location-city.e0223d53.svg";